/**
 * product image / product card image change handler
 * this script handles image preloading and hover functionality for product images across the store
 * it can be used in product cards and product pages
 */

const CONTAINER_SELECTOR = '[data-enable-hover]';
const VARIANT_IMAGE_SELECTOR = '[data-option-hover-image]';

// this is a set to track of initialized containers
const initializedContainers = new Set();

const findMainImage = (container) => {
  // Try to find regular product card first
  const productCard = container.closest('.product__card');
  if (productCard) {
    const imageContainer = productCard.querySelector('.product__image-container');
    return imageContainer?.querySelector('picture img');
  }

  // Try to find bestselling product card
  const bestsellingCard = container.closest('.bestselling-products__list__item');
  if (bestsellingCard) {
    const imageContainer = bestsellingCard.querySelector('.bestselling-products__image');
    return imageContainer?.querySelector('picture img');
  }

  // If no product card found and we're on a product page, get the main product image
  if (window.location.pathname.includes('/products/')) {
    return document.querySelector('.product__image-container img');
  }

  return null;
};

const preloadImages = (variantItems) => {
  const preloadVariantImages = () => {
    variantItems.forEach(item => {
      const imageUrl = item.dataset.optionHoverImage;
      if (!imageUrl) return;

      const preloadLink = document.createElement('link');
      preloadLink.rel = 'preload';
      preloadLink.as = 'image';
      preloadLink.href = imageUrl;
      document.head.appendChild(preloadLink);

      ['300', '600', '900'].forEach(size => {
        const img = new Image();
        img.src = `${imageUrl}&width=${size}`;
      });
    });
  };

  if (window.requestIdleCallback) {
    requestIdleCallback(preloadVariantImages);
  } else {
    setTimeout(preloadVariantImages, 1000);
  }
};

const initializeHoverEvents = (variantItems, mainImage) => {
  variantItems.forEach(item => {
    // Skip if this item is already initialized
    if (item.hasAttribute('data-hover-initialized')) return;

    const handleMouseEnter = () => {
      const variantImageUrl = item.dataset.optionHoverImage;
      console.log('variant image hovered:', item);
      if (!variantImageUrl || !mainImage) return;

      const originalSrc = mainImage.src;
      const originalSrcset = mainImage.srcset || '';

      mainImage.src = variantImageUrl;
      mainImage.srcset = `${variantImageUrl}&width=300 300w, ${variantImageUrl}&width=600 600w, ${variantImageUrl}&width=900 900w`;

      item.dataset.originalSrc = originalSrc;
      item.dataset.originalSrcset = originalSrcset;
    };

    const handleMouseLeave = () => {
      const originalSrc = item.dataset.originalSrc;
      const originalSrcset = item.dataset.originalSrcset;
      
      if (originalSrc && mainImage) {
        mainImage.src = originalSrc;
        if (originalSrcset) {
          mainImage.srcset = originalSrcset;
        }
      }
    };

    // we remove erxisting event listeners if they exist
    item.removeEventListener('mouseenter', handleMouseEnter);
    item.removeEventListener('mouseleave', handleMouseLeave);

    // we add new event listeners
    item.addEventListener('mouseenter', handleMouseEnter);
    item.addEventListener('mouseleave', handleMouseLeave);

    // we mark the item as initialized so it do't get initialized again
    item.setAttribute('data-hover-initialized', 'true');
  });
};

export const initProductImageChange = () => {
  const containers = document.querySelectorAll(CONTAINER_SELECTOR);
  
  containers.forEach(container => {
    // skip if this container is already initialized
    if (initializedContainers.has(container)) return;

    const mainImage = findMainImage(container);
    if (!mainImage) return;

    const variantItems = container.querySelectorAll(VARIANT_IMAGE_SELECTOR);
    if (variantItems.length === 0) return;

    preloadImages(variantItems);
    initializeHoverEvents(variantItems, mainImage);

    // we add the container to the initialized containers set so it do't get initialized again
    initializedContainers.add(container);
  });
};

window.initProductImageChange = initProductImageChange;

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initProductImageChange);